import {
  ProductOutlined,
  PartitionOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { Button, Tabs } from "antd";
import styled from "styled-components";
import Workflows from "./Workflows";
import Templates from "./Templates";

export default function Home() {
  const items = [
    {
      key: "workflow",
      label: "Workflows",
      icon: <StyledIcon as={PartitionOutlined} />,
      children: <Workflows />,
    },
    {
      label: "Templates",
      key: "template",
      icon: <StyledIcon as={ProductOutlined} />,
      children: <Templates />,
    },
  ];

  const operations = (
    <Button color="primary" variant="filled" icon={<FilterOutlined />}/>
  );

  return (
    <Tabs
      items={items}
      tabBarExtraContent={operations}
      defaultActiveKey="workflow"
    />
  );
}

const StyledIcon = styled.div`
  font-size: 18px;
  cursor: pointer;
`;
